import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'userInfo',
      'permissions',
    ]),
    checkFixed() {
      if (window.innerWidth >= 768)
        return 'right'
      return false
    },
    // 统一判断是 pc、mobile
    device() {
      return document.body.clientWidth <= 1099 ? "mobile" : "pc"
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/computedCommon.js